export const PERMISSION_GROUPS = {
  ADMINISTRATORS: "Administrators",
  USER_MANAGER: "User Manager",
  OPERATOR: "Operator",
  READER: "Reader",
  ANALYST: "Analyst",
  SENIOR_OPERATOR: "Senior Operator",
  SUPPORT: 'Support',
  MLN_HK: 'MLN-HK',
}
